module.exports = __webpack_public_path__ + "static/media/order.703d04b3.svg";